export class Translate {
    public static LanguageForCombo(){
        return [
            { code: 'EN', i18nKey: 'languages.english' },
            { code: 'FR', i18nKey: 'languages.french' },
            //{ code: 'de', i18nKey: 'languages.german' },
            { code: 'ES', i18nKey: 'languages.spanish' },
            //{ code: 'pt', i18nKey: 'languages.portuguese' },
            //{ code: 'nl', i18nKey: 'languages.dutch' },
            //{ code: 'pl', i18nKey: 'languages.polish' },
            //{ code: 'ro', i18nKey: 'languages.romanian' },
            //{ code: 'cs', i18nKey: 'languages.czech' },
            //{ code: 'zh', i18nKey: 'languages.chinese' },
            //{ code: 'ja', i18nKey: 'languages.japanese' },
            //{ code: 'ar', i18nKey: 'languages.arabic' },
            { code: 'IT', i18nKey: 'languages.italian' },
        ];
    }
}